export const ANALYTIC_SOURCE_PARAM = {
  ReferralToken: 'referral_token',
  AffiliateToken: 'affiliate_token',
  Token: 'token',
  UtmSource: 'utm_source',
  UtmMedium: 'utm_medium',
  CampaignId: 'campaign_id',
  UtmId: 'utm_id',
  UtmCampaign: 'utm_campaign',
  UtmTerm: 'utm_term',
  UtmContent: 'utm_content',
  Fbclid: 'fbclid',
  Gclid: 'gclid',
  Ttclid: 'ttclid',
  Msclkid: 'msclkid',
  Tblci: 'tblci',
  ClickId: 'click_id',
  ClickIdAlt: 'clickid',
  Aclid: 'aclid',
  Cid: 'cid',
  Subid: 'subid',
  Twclid: 'twclid',
} as const;

export type AnalyticSourceParamName = (typeof ANALYTIC_SOURCE_PARAM)[keyof typeof ANALYTIC_SOURCE_PARAM];
export type AnalyticSourceParamInput = AnalyticSourceParamName | readonly AnalyticSourceParamName[];
